import {classNames, observer, React, useAsync} from '@api'
import { LibraryFiltersPopoverButton } from '@design-board'
import { HeaderSyncIndicator } from '@modules/syncIndicator'
import {useStores} from '@modules/VipLocalStore'
import { Workspace } from '@stores'
import { SideBarHeader } from 'centric-ui-components'
import * as css from './LeftSidebarHeader.css'



const HeaderExtra = observer(function headerExtra() {
  const stores = useStores(),
    {
      sidebar: {
        left: {
          workspaces, align, selectedCatalogFieldLibrary,
          selectedLibrary, selectedPathItem, catalog, selectedLibraryConfig
        }
      },
      syncProgress, workspaces: {workspaceConfig, getWorkspaceLastSync},
      deployments: {isNewSync}
    } = stores,
    workspace: Workspace = selectedLibraryConfig?.index ? _.first(workspaces.workspaceByIndex[selectedLibraryConfig.index]) : null,
    {value: lastSyncInfo} = useAsync<string>(async () => {
      return workspace ? await getWorkspaceLastSync(workspace) : null
    }, [workspaceConfig?._id, workspace?.catalog ? syncProgress.byId.get(workspace.catalog.index)?.itemId : null])

  if (!selectedPathItem?.libraryId || selectedPathItem?.where) return null

  return (
    <div className={css.libraryExtra}>
      {selectedCatalogFieldLibrary?.section && <span className={css.sectionChip}>{catalog.sectionById[selectedCatalogFieldLibrary.section]?.label}</span>}
      {workspace?.catalog?.index && !isNewSync && <HeaderSyncIndicator lastSyncTimeMap={new Map([[selectedLibraryConfig?.index, lastSyncInfo]])} itemId={workspace.catalog.index} workspace={workspace} isSyncIndex trigger={'library'}/>}
      {selectedLibrary && selectedLibrary?.filter !== false && <LibraryFiltersPopoverButton library={selectedLibrary} align={align}/>}
    </div>)
})

export const LeftSidebarHeader = observer(function LeftSidebarHeader() {
  const {flexLayout: {isMaximized}, sidebar: {left: {onGoBack, showBackButton, selectedTab, open, selectedLibraryConfig, selectedCatalogFieldLibrary, sidebarHeaderLabel}}} = useStores()
  return (
    ((isMaximized && selectedTab == 'filters') || (!selectedLibraryConfig && !selectedCatalogFieldLibrary))
    ? null
    : <SideBarHeader className={classNames(css.sidebarHeader)}
                     onClickDrawerBack={showBackButton ? onGoBack : undefined}
                     open={open}
                     title={sidebarHeaderLabel}
                     extra={<HeaderExtra/>}
                     location={selectedLibraryConfig || selectedCatalogFieldLibrary ? 'inline' : 'topBar'}
    />)
})



// WEBPACK FOOTER //
// ./src/modules/catalog/sidebar/LeftSidebar/LeftSidebarHeader.tsx